@if (isLoaded$ | async) {
  <ng-container #gridContainer class="flex h-full grow flex-col">
    <!-- Error Message -->
    @if (isError) {
      <div class="p-4 text-center">
        <div class="text-base font-semibold text-gray-600">
          {{ componentTitle }}
        </div>
      </div>
      <ag1-bettabase-error
        class="flex grow items-center justify-center p-6"
        [errorName]="errorName"
        [errorMessage]="errorMessage"
      />
    } @else {
      <div class="my-2 flex items-center justify-between">
        <div class="text-base font-semibold text-gray-600">
          {{ componentTitle }}
        </div>
        <p-button
          size="small"
          (click)="exportCsvButton()"
          [disabled]="isDownloading$ | async"
          pTooltip="Export To CSV"
          tooltipPosition="left"
        >
          <ng-template #icon>
            <svg-icon src="/assets/icons/general/download.svg" />
          </ng-template>
        </p-button>
      </div>
      <ag-grid-angular
        style="
          width: 100%;
          height: 100%;
          font-family: &quot;DM Sans&quot;, sans-serif;
          min-height: 400px;
        "
        [style.height]="componentHeight"
        class="ag-theme-alpine"
        [gridOptions]="gridOptions"
        [rowData]="isServerSide ? [] : (rowData$ | async)"
        (gridReady)="onGridReady($event)"
        [loadingOverlayComponent]="loadingOverlayComponent"
        [loadingOverlayComponentParams]="loadingOverlayComponentParams"
      />
    }
    <!-- Grid Content (Default Case) -->
  </ng-container>
} @else {
  <div class="grid h-full w-full grow place-items-center gap-2 p-5">
    <ag1-loader />
  </div>
}

<!-- Loading State -->
